var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.69573 10.0443L7.69579 10.0444C7.77527 10.1199 7.88823 10.1666 8.01104 10.1667L7.69573 10.0443ZM7.69573 10.0443L3.9624 6.49605L3.96245 6.49599M7.69573 10.0443L3.96245 6.49599M3.96245 6.49599L3.95606 6.49013M3.96245 6.49599L3.95606 6.49013M3.95606 6.49013C3.91569 6.45306 3.88499 6.41013 3.86441 6.3646C3.84386 6.31914 3.83346 6.27126 3.83302 6.22354C3.83259 6.17582 3.84211 6.12786 3.86177 6.0822C3.88145 6.03646 3.91127 5.99317 3.95083 5.95557C3.99045 5.91792 4.03895 5.88686 4.09413 5.8654C4.14934 5.84393 4.20932 5.83285 4.27032 5.83335C4.33133 5.83385 4.39103 5.84592 4.44573 5.86826C4.50039 5.89058 4.54818 5.92236 4.58698 5.96053L4.58692 5.96058M3.95606 6.49013L4.58692 5.96058M4.58692 5.96058L4.59322 5.96657M4.58692 5.96058L4.59322 5.96657M4.59322 5.96657L7.66669 8.8877L8.01114 9.21508M4.59322 5.96657L8.01114 9.21508M8.01114 9.21508L8.3556 8.8877M8.01114 9.21508L8.3556 8.8877M8.3556 8.8877L11.4253 5.97014C11.5054 5.89786 11.6168 5.85416 11.737 5.85515C11.8584 5.85616 11.9699 5.90265 12.0485 5.97737C12.1263 6.05132 12.1655 6.14588 12.1663 6.23907C12.1672 6.33122 12.1306 6.42508 12.0561 6.49963L8.32655 10.0443L8.3265 10.0444M8.3556 8.8877L8.3265 10.0444M8.3265 10.0444C8.24702 10.1199 8.13405 10.1666 8.01125 10.1667L8.3265 10.0444Z",
    fill: "#1F2A37",
    stroke: "#156763"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.c1c494043cc258775984b64ff93904cf.svg";
export { ForwardRef as ReactComponent };